import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface PropsRender {
  name: AllIcons
  isActive?: boolean
}

export const RenderIconAvaliable = ({
  name,
  isActive = false,
}: PropsRender) => {
  return (
    <AppIcon
      id={name}
      width={20}
      height={20}
      className={isActive ? s.icon : s.icon_disable}
    />
  )
}
